<template>
  <div class="echarts" id="echartsTopLeft"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  inject,
  watchEffect,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { prisonlist } from "@/api/threeSolid/threeSolidHome.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: [],
    });
    const refData = toRefs(data);
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          echartsTopLeft();
        });
      }
    });
    // const areaData = inject("areaData");
    // watchEffect(() => {
    //   if (areaData.value) {
    //     nextTick(() => {
    //       echartsTopLeft();
    //     });
    //   }
    // });
    const numberall = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await prisonlist(param);
      data.echartsList = res.data;
    };

    let myChartTopLeft;
    const echartsTopLeft = async () => {
      myChartTopLeft = echarts.init(document.getElementById("echartsTopLeft"));
      await numberall();
      const option = {
        color: [
          "#ecab3c",
          "#ded747",
          "#3d8eb7",
          "#5dc8d8",
          "#67c99c",
          "#97b939",
        ],
        title: [
          {
            //   text: '总计' + (2 +
            // 4 +
            // 6 +
            // 8),
            // text:data.echartsList[0].value +":"+data.echartsList[1].value,
            subtext: "性别比例",
            // x: "center",
            // y: "center",
            left: "49%",
            top: "38%",
            textAlign: "center",
            textStyle: {
              height: 10,
              fontWeight: "normal",
              fontSize: "12",
              color: "#00f6ff",
              // textAlign: "center",
            },
            subtextStyle: {
              color: "#00f6ff",
              fontSize: "12",
            },
          },
        ],
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "实有人口",
            type: "pie",
            radius: ["30%", "65%"],
            center: ["50%", "50%"],
            startAngle: "180",
            label: {
              formatter: "{name|{b}} {time|{d} %}",
              rich: {
                time: {
                  fontSize: 14,
                  lineHeight: 24,
                  color: "#2da6dd",
                },
                name: {
                  fontSize: 14,
                  color: "#fff",
                },
              },
            },
            labelLine: {
              length: 20,
              length2: 10,
              lineStyle: {
                color: "#46e6c3",
                width: 2,
              },
            },
            itemStyle: {
              borderColor: "#4a73d4",
              borderWidth: 3,
            },
            data: data.echartsList,
            // data: [
            //   { value: 2, name: '一级危险源' },
            //   { value: 4, name: '二级危险源' },
            //   { value: 6, name: '三级危险源' },
            //   { value: 8, name: '四级危险源' }
            // ],
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChartTopLeft.setOption(option);
    };
    onMounted(() => {
      echartsTopLeft();
      window.addEventListener("resize", () => {
        myChartTopLeft.resize();
      });
    });

    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
#echartsTopLeft {
  width: 100%;
  height: 55%;
}
</style>
